import { ChannelEndpoint } from '@/modules/notification-center/event-trigger/api/channelEndpoint'
import { NotificationTriggerEndpoints } from '@/modules/notification-center/event-trigger/api/triggerEndpoints'

export const notificationTriggerEndpoints = new NotificationTriggerEndpoints()

// TODO: Remove this when we have channel module
export const channelEndpoints = new ChannelEndpoint()
